//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    width: 510px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px;
    & header {
        display: flex;
        flex-direction: column;
        align-items: center;
        & img {
            width: 85px;
            margin-top: -200px;
        }
        & h3 {
            margin: 0;
        }
    }
    & > *:last-child {
        width: 100%;
    }
    & img {
        width: 20px;
    }
`;